import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container login-register-wrapper-box-container" }
const _hoisted_2 = { class: "row my-5 justify-content-center" }
const _hoisted_3 = { class: "col-lg-7 col-12" }
const _hoisted_4 = { class: "container" }

import { onBeforeUnmount, onMounted, onUnmounted } from 'vue'

  // Config
  import UserInfoFormEnum from '@/config/UserInfoFormEnum'

  // Components
  import LoginRegisterResetWrapperBox from '@/components/LoginRegister/LoginRegisterResetWrapperBox.vue'

  // common components
  import Overlay from '@/components/common/Overlay/v1/Overlay.vue'
  import StickyBar from '@/components/UI/StickyBar.vue'

  // logic
  // import refresh from "@/logic/contact/refresh"

  // Utils
  import { getQueryParams } from '@/utils'

  // Composables
  import useLoading from '@/composables/useLoading'

  // Store
  import { useStore } from 'vuex'

  // Cookies
  import Cookies from 'js-cookie'
  import { State } from '@/store/types'
  import { UserInfo } from '@/services/AuthService.interface'

  import current_form from '@/state/current_form'

  // Login state
  import locale from '@/state/locale'

  // Logic
  import navigateAfterAuth from '@/logic/contact/navigateAfterAuth'

  import { CookieName } from '@/config/cookies'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginVIew',
  setup(__props) {

  // Vue
  const store = useStore<State>()

  const checkHasRefreshToken = (): boolean => {
    const refreshToken = Cookies.get(CookieName.REFRESH_TOKEN)
    return !!refreshToken
  }

  onMounted(async () => {
    locale.value = store.getters.getLocale

    const queryParams = getQueryParams()

    const hasRefreshToken: boolean = checkHasRefreshToken()

    // If we have the hash, that means we should show the new password form
    if (queryParams.hash) {
      current_form.value = UserInfoFormEnum.NewPassword
      return
    }

    if (!store.state.auth?.user) {
      current_form.value = UserInfoFormEnum.Check
    }

    if (!hasRefreshToken) return

    const { startLoadingThis, stopLoadingThis } = useLoading()
    try {
      startLoadingThis()

      const userInfo: UserInfo = await store.dispatch('auth/refresh')

      if (queryParams.redirect_to) {
        window.location.href = queryParams.redirect_to
        return
      }

      if (userInfo) {
        await navigateAfterAuth(userInfo.email)
      }
    } catch (err) {
      stopLoadingThis()
    }
  })

  onBeforeUnmount(() => {
    current_form.value = UserInfoFormEnum.Check
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LoginRegisterResetWrapperBox)
        ])
      ])
    ])
  ]))
}
}

})